import { isNumber, memoizeFunction } from '@agilepoint/utils-common';

const regex = /\d+|\w+/g;

export function splitTime(time: string, is12Hour: boolean | undefined, timeSeperator: string): string[] {
    if (!time) { return []; }
    if (is12Hour) {
        const splittedTime = time.match(regex);
        if (splittedTime) {
            return splittedTime;
        }
    }
    return time.split(timeSeperator);
}

export const timeValidator = {
    isValidHour(hour: string, is12Hour: boolean | undefined): boolean {
        return is12Hour ? this.isValid12Hour(hour) : this.isValid24Hour(hour);
    },

    isValid12Hour: memoizeFunction((hour = '01'): boolean => (isNumber(Number(hour)) && Number(hour) < 24 && hour !== '0')),

    isValid24Hour: memoizeFunction((hour = '00'): boolean => (isNumber(Number(hour)) && Number(hour) < 24)),

    isValidMinute: memoizeFunction((minute = '00'): boolean => (isNumber(Number(minute)) && minute[0] < '6' && minute.length <= 2)),

    isValidAmPm: memoizeFunction((amPm = 'AM'): boolean => (amPm.toLowerCase().includes('am') || amPm.toLowerCase().includes('pm'))),

    isValidTime(time: string, is12Hour: boolean | undefined, timeSeperator: string): boolean {
        const [hour, minute = '00', amPm] = splitTime(time, is12Hour, timeSeperator);

        const splittedMinute = minute.match(regex);
        const newMinute = is12Hour ? minute : splittedMinute ? splittedMinute[0] : minute;

        const isValidHour = this.isValidHour(hour, is12Hour);
        const isValidMinute = this.isValidMinute(newMinute);
        const isValidAmPm = is12Hour ? this.isValidAmPm(amPm) : minute.includes('') ? this.isValidAmPm(minute.split(' ')[1]) : true;
        return isValidHour && isValidMinute && isValidAmPm;
    }
};
